export function isSafeRedirectUrl(url: string | null | undefined): boolean {
  if (!url || typeof url !== "string") return false;
  const trimmed = url.trim();
  if (!trimmed) return false;

  try {
    const parsed = new URL(trimmed, window.location.origin);
    // Parsed as the browser will: "//host", "/\\host" or "/<tab>/host" is another site.
    if (trimmed.startsWith("/"))
      return parsed.origin === window.location.origin;
    return parsed.protocol === "https:" || parsed.protocol === "http:";
  } catch {
    return false;
  }
}

export default isSafeRedirectUrl;
